import { Component, OnInit, Input, Output, OnDestroy, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as api from '../../shared/api/apihandler';
import { ColorList } from 'app/bars/topbar/topbarData';
import { Subject} from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CaseFunctions, CaseSettings } from 'app/shared-html-components/details/caseFunctions';
import { SubscriptionObject } from 'app/shared/models/standard.models';
import { UserService } from 'app/shared/services/user.service';

@Component({
  selector: 'customer-card',
  templateUrl: './customer-card.component.html',
  styleUrls: ['./customer-card.component.css']
})
export class CustomerCardComponent implements OnInit, OnDestroy, OnChanges {

  @Input() data: any;
  @Input() propertyId: string | null = null;
  @Input() caseSettings: PrimaryCustomer | null = null;;
  @Output() caseSettingsChange = new EventEmitter<string>();
  @Input('options') opts: CustomerCardOptions | null = null; 
  @Output() dataChange = new EventEmitter<boolean>();
  options: CustomerCardOptions = {
    disableEdit:false,
    disableRouting: false
  }
  api = new CaseFunctions(this.http);
  customerView: PrimaryCustomer = 'customer';
  mode: string = 'new';
  customerMenuWindow: boolean = false;
  details!: CustomerDetails;
  selected?: CustomerInfo;
  customer?: CustomerInfo;
  allCustomers: Array<CustomerList> | null = null;
  allDeliveryContact: Array<CustomerInfo> | null = null;
  shownCustomers: Array<CustomerList> | null = null;
  changeCustomerInfo: CustomerList | null = null;
  descending: boolean = false;
  startIndex = 0;
  endIndex = 30;
  who: string = '';
  searchAmount = 60;
  scrollDistance = 1;
  scrollUpDistance = 2;
  throttle = 150;
  modelChanged: Subject<string> = new Subject<string>();
  subs: SubscriptionObject = {}
  searchVal: string = '';
  searchText: string = '';
  existingDeliveryContact: Array<CustomerInfo> | null = null;
  allExistingDeliveryContact: Array<CustomerInfo> | null = null;
  //chosenDeliveryContact: CustomerInfo;
  debounceTime = 500;

  constructor(private http: HttpClient, private router: Router, private user: UserService) { }

  ngOnInit(): void {
    this.api.caseCommunication(this.data.caseId).subscribe({
      next: (data: Array<CaseSettings>) => {
        if (!!data && data.length > 0 && !!data.find(x => x.settingId == '2181f86a-e06d-412e-88e8-6f47619232a0')) {
          let view = data.find(x => x.settingId == '2181f86a-e06d-412e-88e8-6f47619232a0');
          this.customerView = !!view ? view.value as PrimaryCustomer : 'customer';
        }
        this.checkCommExists();
      },
      error: err => console.error(err)
    });
    document.addEventListener("click", (evt: any) => this.customerMenuListener(evt));
    this.subs['modelChanged'] = this.modelChanged.pipe(debounceTime(this.debounceTime)).subscribe(() => { this.searchCustomers(); });
  }

  ngOnChanges(changes: SimpleChanges): void {
    let cus = this.data.customer;
    let inv = this.data.invoice;
    let del = this.data.deliveryAddress;
    let con = this.data.contactAddress;
    if (!!changes && !!changes.data && !!changes.data.currentValue) {
      this.details = {
        customer: {
          id: cus.customerId,
          name: cus.name,
          address: cus.address,
          email: cus.email,
          phone: cus.phone,
          mobile: cus.mobile,
          zipCode: cus.zipCode,
          city: cus.city,
          att: cus.att,
          cvr: cus.cvr,
          number: cus.customerNumber,
          ean: cus.ean
        },
        invoice: {
          id: inv.id,
          name: inv.name,
          address: inv.address,
          email: inv.email,
          phone: inv.phone,
          mobile: inv.mobile,
          zipCode: inv.zipCode,
          city: inv.city,
          att: undefined,
          cvr: undefined,
          number: undefined,
          ean: undefined
        },
        delivery: {
          id: del.id,
          name: del.name,
          address: del.address,
          email: del.email,
          phone: del.phone,
          mobile: del.mobile,
          zipCode: del.zipCode,
          city: del.city,
          att: undefined,
          cvr: undefined,
          number: undefined,
          ean: undefined
        },
        contact: {
          id: con.id,
          name: con.name,
          address: con.address,
          email: con.email,
          phone: con.phone,
          mobile: con.mobile,
          zipCode: con.zipCode,
          city: con.city,
          att: undefined,
          cvr: undefined,
          number: undefined,
          ean: undefined
        },
      }
    }
    if(!!changes.opts && !!changes.opts.currentValue) this.options = {...this.options, ...changes.opts.currentValue};

    if(!!changes.caseSettings && !!changes.caseSettings.currentValue) this.customerView = changes.caseSettings.currentValue; 
  }

  ngOnDestroy(): void {
    for(let key of Object.keys(this.subs)) this.subs[key].unsubscribe();
  }

  checkCommExists() {
    switch (this.customerView) {
      case 'delivery':
        this.customerView = !!this.details.delivery.id ? 'delivery' : 'customer';
        break;
      case 'contact':
        this.customerView = !!this.details.contact.id ? 'contact' : 'customer';
        break;
      default:
        break;
    }
    this.changeNotificationAddress(this.customerView);
  }

  changeNotificationAddress(target:PrimaryCustomer) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') as string });
    this.http.patch(api.jubloApi + 'api/Website/Case/NotificationReceiver/' + this.data.caseId + '/' + target, {}, { headers }).subscribe({
      next:()=> this.caseSettings = target,
      error: err => console.error(err)
    });
  }

  openEditModal() {
    this.customerMenuWindow = false;
    this.mode = 'edit';
    switch (this.customerView) {
      case 'customer':
      case 'invoice':
        this.customer = this.details.customer;
        this.selected = this.details.invoice;
        break;
      case 'delivery':
        this.selected = this.details.delivery;
        break;
      case 'contact':
        this.selected = this.details.contact;
        break;
    }
  }

  openNewModal() {
    this.customerMenuWindow = false;
    this.mode = 'add';
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') as string });
    switch (this.customerView) {
      case 'customer':
        this.selected = new CustomerInfo;
        break;
      case 'invoice':
        this.selected = new CustomerInfo;
        break;
      case 'delivery':
        this.http.get<Array<CustomerInfo>>(api.jubloApi + 'api/Website/Customer/GetDeliveryAddressesPagination/' + this.data.customer.customerId + '/0/200', { headers }).subscribe({
          next: (data) => {
            this.allExistingDeliveryContact = data.sort((a, b) => !!a.name && !!b.name && a.name < b.name ? -1 : 1);
            this.existingDeliveryContact = this.allExistingDeliveryContact;
          },
          error: err => console.error(err),
          complete: () => { this.selected = new CustomerInfo; }
        });
        break;
      case 'contact':
        this.http.get<Array<CustomerInfo>>(api.jubloApi + 'api/Website/Customer/GetContactAddressesPagination/' + this.data.customer.customerId + '/0/200', { headers }).subscribe({
          next: (data) => {
            this.allExistingDeliveryContact = data.sort((a, b) => !!a.name && !!b.name && a.name < b.name ? -1 : 1);
            this.existingDeliveryContact = this.allExistingDeliveryContact;
          },
          error: err => console.error(err),
          complete: () => { this.selected = new CustomerInfo; }
        });
        break;
    }
    document.getElementById('openModalCreateBtn')!.click();
  }

  selectExistingId(item: CustomerInfo) {
    document.getElementById('addNewCloseBtn')!.click();
    this.details[this.customerView] = item;
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') as string });
    switch (this.customerView) {
      case 'customer':
        this.http.patch(api.jubloApi + 'api/Website/Case/ChangeCustomer/' + item.id + '/' + this.data.caseId, {}, { headers }).subscribe({
          error: err => console.error(err)
        });
        break;
      case 'invoice':
        this.http.patch(api.jubloApi + 'api/Website/Case/ChangeCustomer/' + item.id + '/' + this.data.caseId, {}, { headers }).subscribe({
          error: err => console.error(err)
        });
        break;
      case 'contact':
        this.http.patch(api.jubloApi + 'api/Website/Case/ChangeContact/' + item.id + '/' + this.data.caseId, {}, { headers }).subscribe({
          complete:() => { if(this.caseSettings != 'contact') this.changeNotificationAddress('contact') },
          error: err => console.error(err)
        });
        break;
      case 'delivery':
        this.http.patch(api.jubloApi + 'api/Website/Case/ChangeDelivery/' + item.id + '/' + this.data.caseId, {}, { headers }).subscribe({
          error: err => console.error(err)
        });
        break;
      default:
        break;
    }
  }

  saveChanges() {
    switch (this.customerView) {
      case 'customer':
      case 'invoice':
        let id = this.data.customer.customerId
        this.data.customer = this.customer;
        this.data.invoice = this.selected;
        this.data.customer.customerId = id;
        this.updateCustomer();
        break;
      case 'delivery':
        this.data.delivery = this.selected;
        this.updateDelivery();
        break;
      case 'contact':
        this.data.contact = this.selected;
        this.updateContact();
        break;
    }
  }

  changeReciever() {
    this.caseSettings = this.customerView;
    this.caseSettingsChange.emit(this.customerView);
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') as string });
    this.http.patch(api.jubloApi + 'api/Website/Case/NotificationReceiver/' + this.data.caseId + '/' + this.caseSettings, {}, { headers }).subscribe({
      error: err => console.error(err)
    });
  }

  createNew() {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') as string });
    switch (this.customerView) {
      case 'customer': break;
      case 'invoice':  break;
      case 'delivery': {
        this.details.delivery = this.selected!;
        let data = {
          customerId: this.details.customer.id,
          name: this.selected!.name,
          address: this.selected!.address,
          city: this.selected!.city,
          zipCode: this.selected!.zipCode,
          telephone: this.selected!.phone,
          mobile: this.selected!.phone,
          email: this.selected!.email
        }
        this.http.post<any>(api.jubloApi + 'api/Website/Customer/AddDeliveryAddress', data, { headers }).subscribe({
          next: (data) =>  this.details.delivery.id = data,
          error: err => console.error(err),
          complete: () => {
            if (!!this.details.delivery.id) {
              this.http.patch(api.jubloApi + 'api/Website/Case/ChangeDelivery/' + this.details.delivery.id + '/' + this.data.caseId, {}, { headers }).subscribe({
                error: err => console.error(err),
                complete:() => this.changeNotificationAddress('delivery')
              });
            }
          }
        });
        break;
      }
      case 'contact': {
        this.details.contact = this.selected!;
        this.details.contact.mobile = this.selected!.phone;
        let data = {
          customerId: this.details.customer.id,
          name: this.selected!.name,
          address: this.selected!.address,
          city: this.selected!.city,
          zipCode: this.selected!.zipCode,
          telephone: this.selected!.phone,
          mobile: this.selected!.phone,
          email: this.selected!.email
        }
        this.http.post<any>(api.jubloApi + 'api/Website/Customer/AddContactAddress', data, { headers }).subscribe({
          next: (data) =>  this.details.contact.id = data,
          error: err => console.error(err),
          complete: () => {
            this.changeNotificationAddress('contact');
            if (!!this.details.contact.id) {
              this.http.patch(api.jubloApi + 'api/Website/Case/ChangeContact/' + this.details.contact.id + '/' + this.data.caseId, {}, { headers }).subscribe({
                error: err => console.error(err)
              });
            }
            
          }
        });
        break;
      }
    }
  }

  updateCustomer() {
    let cus = this.data.customer;
    let inv = this.data.invoice;
    let data = {
      number: cus.number,
      name: cus.name,
      phone: cus.phone,
      mobile: cus.mobile,
      address: cus.address,
      city: cus.city,
      zipCode: cus.zipCode,
      email: cus.email,
      invoiceName: inv.name,
      invoicePhone: inv.phone,
      invoiceMobile: inv.mobile,
      invoiceAddress: inv.address,
      invoiceCity: inv.city,
      invoiceZipCode: inv.zipCode,
      invoiceEmail: inv.email,
      cvr: cus.cvr,
      att: cus.att,
      ean: cus.ean
    }
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') as string });
    this.http.put(api.jubloApi + 'api/Website/Customer/EditCustomer/' + this.selected!.id, data, { headers }).subscribe({
      error: err => console.error(err),
      complete: ()=> this.dataChange.emit(true)
    });
  }

  updateDelivery() {
    let del = this.data.delivery;
    let data = {
      name: del.name,
      address: del.address,
      city: del.city,
      zipCode: del.zipCode,
      mobile: del.mobile,
      phone: del.phone,
      email: del.email
    }
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') as string });
    this.http.put(api.jubloApi + 'api/Website/Customer/EditDelivery/' + del.id, data, { headers }).subscribe({
      error: err => console.error(err),
      complete: ()=> this.dataChange.emit(true)
    });
  }

  updateContact() {
    let con = this.data.contact;
    let data = {
      name: con.name,
      address: con.address,
      city: con.city,
      zipCode: con.zipCode,
      telephone: con.phone,
      mobile: con.mobile,
      email: con.email
    }
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') as string });
    this.http.put(api.jubloApi + 'api/Website/Customer/EditContact/' + con.id, data, { headers }).subscribe({
      error: err => console.error(err),
      complete: ()=> this.dataChange.emit(true)
    });
  }

  deleteContactDelivery() {
    if (this.customerView == 'delivery') {
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') as string });
      this.http.patch(api.jubloApi + 'api/Website/Case/RemoveDelivery/' + this.data.caseId, {}, { headers }).subscribe({
        error: err => console.error(err),
        complete: () => {
          this.details.delivery = new CustomerInfo();
          if(this.caseSettings == 'delivery') this.changeNotificationAddress('customer');
        }
      });
    } else {
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') as string });
      this.http.patch(api.jubloApi + 'api/Website/Case/RemoveContact/' + this.data.caseId, {}, { headers }).subscribe({
        error: err => console.error(err),
        complete: () =>  {
          this.details.contact = new CustomerInfo();
          if(this.caseSettings == 'contact') this.changeNotificationAddress('customer');
        }
      });
    }
  }

  prepareSendCustomer(customer: CustomerList) { 
    this.changeCustomerInfo = customer;
  }

  changeCustomer() {
    let newDeliveryId: string | null = null;
    let newContactId: string | null = null;
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') as string });
    switch (this.customerView) {
      case 'customer':
      case 'invoice':
        this.http.patch(api.jubloApi + 'api/Website/Case/ChangeCustomer/' + this.changeCustomerInfo!.customerId + '/' + this.data.caseId, {}, { headers }).subscribe({
          error: err => console.error(err),
          complete: () => {
            this.details.customer = {
              id: this.changeCustomerInfo!.customerId!,
              name: this.changeCustomerInfo!.name,
              address: this.changeCustomerInfo!.customerAddress,
              zipCode: this.changeCustomerInfo!.customerZipCode,
              city: this.changeCustomerInfo!.customerCity,
              phone: this.changeCustomerInfo!.customerPhone,
              mobile: this.changeCustomerInfo!.customerMobile,
              email: this.changeCustomerInfo!.customerEmail
            }
            this.details.invoice = {
              name: this.changeCustomerInfo!.invoiceName,
              address: this.changeCustomerInfo!.invoiceAddress,
              zipCode: this.changeCustomerInfo!.invoiceZipCode,
              city: this.changeCustomerInfo!.invoiceCity,
              phone: this.changeCustomerInfo!.invoicePhone,
              mobile: this.changeCustomerInfo!.invoiceMobile,
              email: this.changeCustomerInfo!.invoiceEmail
            }
            if (!!this.details.delivery.id) {
              this.http.post(api.jubloApi + 'api/Website/Customer/AddDeliveryAddress', {
                customerId: this.changeCustomerInfo!.customerId,
                name: this.details.delivery.name,
                address: this.details.delivery.address,
                city: this.details.delivery.city,
                zipCode: this.details.delivery.zipCode,
                telephone: (!!this.details.delivery.phone ? this.details.delivery.phone.replace(/\s/g, '') : ''),
                mobile: (!!this.details.delivery.mobile ? this.details.delivery.mobile.replace(/\s/g, '') : ''),
                email: this.details.delivery.email
              }, { headers }).subscribe({
                next: (data) => newDeliveryId = data as string,
                error: err => console.error(err),
                complete: () => {
                  if (!!newDeliveryId) {
                    this.http.patch(api.jubloApi + 'api/Website/Case/ChangeDelivery/' + newDeliveryId + '/' + this.data.caseId, {}, { headers }).subscribe({
                      error: err => console.error(err),
                      complete: () => this.dataChange.emit(true)
                    });
                  }
                },
              });
            }
            if (!!this.details.contact.id) {
              this.http.post(api.jubloApi + 'api/Website/Customer/AddContactAddress', {
                customerId: this.changeCustomerInfo!.customerId,
                name: this.details.contact.name,
                address: this.details.contact.address,
                city: this.details.contact.city,
                zipCode: this.details.contact.zipCode,
                telephone: (!!this.details.contact.phone ? this.details.contact.phone.replace(/\s/g, '') : ''),
                mobile: (!!this.details.contact.mobile ? this.details.contact.mobile.replace(/\s/g, '') : ''),
                email: this.details.contact.email
              }, { headers }).subscribe({
                next: (data) => newContactId = data as string,
                error: err => console.error(err),
                complete: () => {
                  if (!!newContactId) {
                    this.changeNotificationAddress('contact');
                    this.http.patch(api.jubloApi + 'api/Website/Case/ChangeContact/' + newContactId + '/' + this.data.caseId, {}, { headers }).subscribe({
                      error: err => console.error(err),
                      complete: () => this.dataChange.emit(true)
                    });
                  }
                },
              });
            }
          }
        });
        break;
      case 'delivery':{
        this.http.patch(api.jubloApi + 'api/Website/Case/ChangeDelivery/' + this.changeCustomerInfo!.customerId + '/' + this.data.caseId, {}, { headers }).subscribe({
          error: err => console.error(err),
          complete: () => {
            this.dataChange.emit(true)
            this.details.delivery = {
              id: this.changeCustomerInfo!.customerId,
              name: this.changeCustomerInfo!.name,
              address: this.changeCustomerInfo!.customerAddress,
              zipCode: this.changeCustomerInfo!.customerZipCode,
              city: this.changeCustomerInfo!.customerCity,
              phone: this.changeCustomerInfo!.customerPhone,
              mobile: this.changeCustomerInfo!.customerMobile,
              email: this.changeCustomerInfo!.customerEmail
            };
            this.changeNotificationAddress('delivery');
          }
        });
        break;
      }
      case 'contact':
        this.http.patch(api.jubloApi + 'api/Website/Case/ChangeContact/' + this.changeCustomerInfo!.customerId + '/' + this.data.caseId, {}, { headers }).subscribe({
          error: err => console.error(err),
          complete: () => {
            this.dataChange.emit(true)
            this.details.contact = {
              id: this.changeCustomerInfo!.customerId,
              name: this.changeCustomerInfo!.name,
              address: this.changeCustomerInfo!.customerAddress,
              zipCode: this.changeCustomerInfo!.customerZipCode,
              city: this.changeCustomerInfo!.customerCity,
              phone: this.changeCustomerInfo!.customerPhone,
              mobile: this.changeCustomerInfo!.customerMobile,
              email: this.changeCustomerInfo!.customerEmail
            };
            this.changeNotificationAddress('contact');
          }
        });
        break;
    }
  }

  getCustomers(start: number, stop: number) {
    this.customerMenuWindow = false;
    this.mode = 'change'
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') as string });
    switch (this.customerView) {
      case 'customer':
      case 'invoice':
        this.http.get<Array<CustomerList>>(api.jubloApi + 'api/Website/Customer/GetCustomersPagination/' + start.toString() + '/' + stop.toString(), { headers }).subscribe({
          next: (data) => { this.allCustomers = data; },
          error: err => console.error(err),
          complete: () => {
            if (!!this.allCustomers) {
              this.sortCustomers(this.endIndex);
            }
          }
        });
        break;
      case 'delivery':
        this.http.get<Array<CustomerInfo>>(api.jubloApi + 'api/Website/Customer/GetDeliveryAddressesPagination/' + this.data.customer.customerId + '/0/200', { headers }).subscribe({
          next: (data) => { this.allDeliveryContact = data; },
          error: err => console.error(err),
          complete: () => {
            if (!!this.allDeliveryContact) {
              this.sortCustomers(this.endIndex);
            }
          }
        });
        break;
      case 'contact':
        this.http.get<Array<CustomerInfo>>(api.jubloApi + 'api/Website/Customer/GetContactAddressesPagination/' + this.data.customer.customerId + '/0/200', { headers }).subscribe({
          next: (data) => { this.allDeliveryContact = data; },
          error: err => console.error(err),
          complete: () => {
            if (!!this.allDeliveryContact) {
              this.sortCustomers(this.endIndex);
            }
          }
        });
        break;
    }

  }

  getCustomerSearch() {
    if (this.who != '') {
      if (this.propertyId == null) {
        const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') as string });
        this.http.get<Array<CustomerList>>(api.jubloApi + 'api/Website/Customer/GetCustomersSearch/' + this.who + '/' + this.searchAmount, { headers }).subscribe({
          next: (data) => { this.allCustomers = data; }
        });
      } else {

      }

    } else {
      if (this.propertyId == null) {
        this.startIndex = 0; this.endIndex = 50;
        this.getCustomers(this.startIndex, this.endIndex);
      } else {

      }
    }
  }

  async sortCustomers(end: number) {
    let multiplier = this.descending ? 1 : -1;
    switch (this.customerView) {
      case 'customer':
      case 'invoice':
        this.shownCustomers = this.allCustomers.sort((a,b) => a.name && a.name.toLowerCase() < b.name && b.name.toLowerCase() ? (-1 * multiplier) : (1 * multiplier) ).slice(0, end);
        break;
      case 'delivery':
      case 'contact':
        this.shownCustomers = await (await this.remapDeliveryContactObject(this.allDeliveryContact!)).sort((a,b)=> a.name && a.name.toLowerCase() < b.name && b.name.toLowerCase() ? (-1 * multiplier) : (1 * multiplier)).slice(0, end);
        break;
    }
  }

  async remapDeliveryContactObject(list: Array<CustomerInfo>) {
    let d = new Array<CustomerList>();
    for (let x of list) {
      d.push({
        customerId: x.id!,
        name: x.name!,
        customerAddress: x.address,
        customerZipCode: x.zipCode,
        customerCity: x.city,
        customerMobile: x.mobile,
        customerPhone: x.phone,
        customerEmail: x.email
      });
    }
    return d;
  }

  inputChanged() {
    this.modelChanged.next("Searching");
  }

  searchCustomers() {
    if (this.searchVal.length < 3) {
      this.getCustomers(0, 30);
    } else {
      let search = this.searchVal.replace(/[^a-zA-Z0-9]+/g, ' ').trim();
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') as string });
      this.http.get<Array<CustomerList>>(api.jubloApi + 'api/Website/Customer/GetCustomersSearch/' + search + '/50', { headers }).subscribe({
        next: (data) => { this.allCustomers = data; },
        error: err => console.error(err),
        complete: () => {
          if (!!this.allCustomers) {
            this.sortCustomers(50);
          }
        }
      });
    }
  }

  onScrollDown() {
    if (this.who == '') {
      this.startIndex += 25;
      this.endIndex += 25;
      this.getCustomers(this.startIndex, this.endIndex);
    } else {
      this.searchAmount = this.searchAmount + 25
      this.getCustomerSearch();
    }
  }

  switchModal(from: string, to: string) {
    switch (from) {
      case 'change':
        document.getElementById('changeCustomerModalCloseBtn')!.click();
        break;
      default:
        break;
    }

    switch (to) {
      case 'create':
        document.getElementById('openModalCreateBtn')!.click();
        this.mode = 'add'
        this.selected = new CustomerInfo;
        break;

      default:
        break;
    }
  }

  customerMenuListener(evt: any) {
    const customerMenuEl = document.getElementById("customerMenuContent");
    let targetEl = evt.target; // clicked element
    do {
      if (targetEl == customerMenuEl) {
        // This is a click inside, does nothing, just return.
        return;
      }
      // Go up the DOM
      targetEl = targetEl.parentNode;
    } while (targetEl);
    // This is a click outside.      
    this.customerMenuWindow = false;
  }

  findCustomer(type: string) {
    let add = '';
    let mail = '';
    let phone = '';
    switch (this.customerView) {
      case 'customer':
        add = !!this.data.customer.address ? this.data.customer.address : '' + ',' + !!this.data.customer.zipCode ? this.data.customer.zipCode : '' + ' ' + !!this.data.customer.city ? this.data.customer.city : '';
        mail = !!this.data.customer.email ? this.data.customer.email : '';
        phone = !!this.data.customer.mobile ? this.data.customer.mobile : (!!this.data.customer.phone ? this.data.customer.phone : '');
        break;
      case 'invoice':
        add = !!this.data.invoice.address ? this.data.invoice.address : '' + ',' + !!this.data.invoice.zipCode ? this.data.invoice.zipCode : '' + ' ' + !!this.data.invoice.city ? this.data.invoice.city : '';
        mail = !!this.data.invoice.email ? this.data.invoice.email : '';
        phone = !!this.data.invoice.mobile ? this.data.invoice.mobile : (!!this.data.invoice.phone ? this.data.invoice.phone : '');
        break;
      case 'delivery':
        add = !!this.data.deliveryAddress.address ? this.data.deliveryAddress.address : '' + ',' + !!this.data.deliveryAddress.zipCode ? this.data.deliveryAddress.zipCode : '' + ' ' + !!this.data.deliveryAddress.city ? this.data.deliveryAddress.city : '';
        mail = !!this.data.deliveryAddress.email ? this.data.deliveryAddress.email : '';
        phone = !!this.data.deliveryAddress.mobile ? this.data.deliveryAddress.mobile : (!!this.data.deliveryAddress.phone ? this.data.deliveryAddress.phone : '');
        break;
      case 'contact':
        add = !!this.data.contactAddress.address ? this.data.contactAddress.address : '' + ',' + !!this.data.contactAddress.zipCode ? this.data.contactAddress.zipCode : '' + ' ' + !!this.data.contactAddress.city ? this.data.contactAddress.city : '';
        mail = !!this.data.contactAddress.email ? this.data.contactAddress.email : '';
        phone = !!this.data.contactAddress.mobile ? this.data.contactAddress.mobile : (!!this.data.contactAddress.phone ? this.data.contactAddress.phone : '');
        break;
      default:
        return;
    }
    if (type == 'map' && !!add && add != '') {
        window.open("http://maps.google.com/maps?q=" + add, "_blank");
    } else if (type == 'email' && !!mail && mail != '') {
        window.open("mailto:" + mail, "_blank");
    } else if (type == 'phone' && !!phone && phone != '') {
        window.open("tel:" + phone, "_self");
    }
  }

  findColor(type: string, name: string) {
    if (!!this.data) {
      let init = !!this.data.deliveryAddress.address ?
        this.data.deliveryAddress.address.trim().substring(0, 1).toUpperCase() :
        (!!this.data.customer.address && !!this.data.customer.address ?
          this.data.customer.address.trim().substring(0, 1).toUpperCase() :
          (!!this.data.invoice.address && !!this.data.customer.address ?
            this.data.invoice.address.trim().substring(0, 1).toUpperCase() : ''));
      let responsible = !!this.data.responsible.name ? this.data.responsible.name.trim().substring(0, 1).toUpperCase() : '';
      if (name == '') {
        switch (type) {
          case 'b':
            if (!!init) {
              return ColorList.colors[init].background;
            } else {
              return '#1F539F';
            }
          case 'c':
            if (!!init) {
              return ColorList.colors[init].color;
            } else {
              return 'white';
            }
          case 'rb':
            if (!!responsible) {
              return ColorList.colors[responsible].background;
            } else {
              return '#1F539F';
            }
          case 'rc':
            if (!!responsible) {
              return ColorList.colors[responsible].color;
            } else {
              return 'white';
            }
          case 'rl':
            if (!!responsible) {
              return responsible;
            } else {
              return '';
            }
          default:
            if (!!init) {
              return init;
            } else {
              return '';
            }
        }
      } else {
        if (!name) return;
        init = name.replace(/[^a-zA-Z]/g, '').substring(0, 1).toUpperCase();
        switch (type) {
          case 'b':
            if (!!init) {
              return ColorList.colors[init].background;
            } else {
              return '#80b8f2';
            }
          case 'c':
            if (!!init) {
              return ColorList.colors[init].color;
            } else {
              return 'white';
            }
          default:
            if (!!init) {
              return init;
            } else {
              return '';
            }
        }
      }
    }
  }

  searchExistingDeliveryOrContact() {
    if (!!this.searchText && this.searchText.length > 0) {
      let search = this.searchText.toLowerCase();
      this.existingDeliveryContact = this.allExistingDeliveryContact!.filter(x =>
        (!!x.address && x.address.toLowerCase().match(search)) ||
        (!!x.name && x.name.toLowerCase().match(search)) ||
        (!!x.mobile && x.mobile.toLowerCase().match(search)) ||
        (!!x.phone && x.phone.toLowerCase().match(search)) ||
        (!!x.email && x.email.toLowerCase().match(search)) ||
        (!!x.number && x.number.match(search))
      );
    } else {
      this.existingDeliveryContact = this.allExistingDeliveryContact;
    }
  }

  goToCustomer() {
    this.router.navigate(['/', 'Customers', 'Customerdetails', this.data.customer.customerId])
  }

  customerToInvoice(){
    let s = this.selected!;
    let c = this.customer!;
    s.name = c.name;
    s.address = c.address;
    s.zipCode = c.zipCode;
    s.city = c.city;
    s.email = c.email;
    s.phone = c.phone;
    s.mobile = c.mobile;
  }

  invoiceToCustomer(){
    let c = this.selected!;
    let s = this.customer!;
    s.name = c.name;
    s.address = c.address;
    s.zipCode = c.zipCode;
    s.city = c.city;
    s.email = c.email;
    s.phone = c.phone;
    s.mobile = c.mobile;
  }

  tabSwitch(tab:PrimaryCustomer){
    this.customerView = tab;
    this.caseSettingsChange.emit(tab);
  }

  changeCompanyCustomer(data: any){
    // type should not be any. It's the return of the dawa cvr search.
    let c = this.customer!;
    c.name = data.name;
    c.address = data.address;
    c.zipCode = data.zipcode;
    c.city = data.city;
    c.email = !!data.email ? data.email : c.email;
    c.phone = !!data.phone ? data.phone : c.phone;
  }
}

export class CustomerDetails {
  customer: CustomerInfo = new CustomerInfo();
  invoice: CustomerInfo = new CustomerInfo();
  delivery: CustomerInfo = new CustomerInfo();
  contact: CustomerInfo = new CustomerInfo();
}

export class CustomerInfo {
  id?: string;
  name?: string;
  address?: string;
  zipCode?: string;
  city?: string;
  phone?: string;
  mobile?: string;
  email?: string;
  cvr?: string;
  att?: string;
  ean?: string;
  number?: string;
}

export class CustomerList {
  customerId?: string;
  customerGroup?: string;
  externalId?: string;
  name?: string;
  customerAddress?: string;
  customerZipCode?: string;
  customerCity?: string;
  customerPhone?: string;
  customerMobile?: string;
  customerEmail?: string;
  invoiceName?: string;
  invoiceAddress?: string;
  invoiceZipCode?: string;
  invoiceCity?: string;
  invoicePhone?: string;
  invoiceMobile?: string;
  invoiceEmail?: string;
  customerNumber?: string;
  propertyInfo?: Array<PropertyInfo>;
  customerTags?: Array<CustomerTags>
}

export class PropertyInfo {
  propertyNumber?: string;
  propertyName?: string;
  propertyLeaseAddress?: string;
  propertyLeaseZipCode?: string;
  propertyLeaseCity?: string;
}

export class CustomerTags {
  customerTagId!: string;
  name!: string;
  color!: string;
}

type PrimaryCustomer = 'customer' | 'invoice' | 'delivery' | 'contact';

class CustomerCardOptions {
  disableEdit: boolean = false;
  disableRouting: boolean = false;
}